// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"6298ea7e","219":"a80ad21d","453":"5a78ba30","464":"2e368bca","683":"6f24f6c5","831":"5ef4540a"}[chunkId] + ".chunk.js";
};